import { TextField, Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyleCheckbox,
  StyledTableCell,
  useStyles,
} from "components/request-document/components/Commons";
import VisaIssuanceSection from "components/request-document/components/VisaIssuanceSection";
import { useFormik } from "formik";
import { REQUEST_DOCUMENT_STEP } from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash-es";
import { React, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartForm,
  addSmartFormSlice,
  getSmartForm,
  getSmartFormFieldConfig,
  selectAddSmartForm,
  selectCurrentSmartForm,
  selectCurrentSmartServiceId,
  selectDraftId,
  selectSmartFormFieldConfig,
} from "redux/modules/visaForm";
import * as yup from "yup";

export default function UserProfileStepC() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);
  const canEdit = useSelector(canEditForm);
  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const draftId = useSelector(selectDraftId);
  const masterData = useSelector(selectMasterData);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const smartform = useSelector(selectCurrentSmartForm);

  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
  const smartformDetail = get(smartform, "detail", []).reduce(
    smartNameById,
    {}
  );

  const personalId = get(personalDetail, "personalID", "");
  const activitiesConfig = get(masterData, "activitiesConfig", []);
  const visaTypeConfig = get(masterData, "visaTypeConfig", []);
  const organiztionTypeConfig = get(masterData, "organiztionTypeConfig", []);
  const countryConfig = get(masterData, "countryConfig", []);
  const ConditionType = get(smartformDetail, "ConditionType.value", "");
  const isGovernment = !(
    ConditionType === "Start up" || ConditionType === "Company"
  );

  const detailList = [
    "OrganiztionName",
    "OrganiztionAddress",
    "OrganiztionPhone",
    "OrganiztionType",
    "RefernceName",
    "ReferncePosition",
    "RefernceEmail",
    "RefernceMobile",
    "DetailsofActivities",
    "activitiesId",
  ];
  const detail = get(smartform, "detail", [])
    .filter((field) => detailList.includes(field.smartName))
    .reduce(smartNameById, {});

  useEffect(() => {
    dispatch(
      getMasterData({
        ActivitiesConfig: true,
        OrganiztionTypeConfig: true,
        CountryConfig: true,
        CityConfig: true,
        VisaTypeConfig: true,
        theImmigrationBureauConfig: true,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [addSmartFormState, dispatch, hideLoading, isSaveDraft]);

  const callAPISubmit = async (values) => {
    showLoading();
    const { visaissuance, ...restValues } = values;

    const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
    const documentFields = Object.keys(restValues);
    const getFieldListConfig = defaultType.filter((field) =>
      documentFields.includes(field.smartName)
    );

    const prepareData = {
      draftId: draftId || null,
      smartserviceId: smartServiceId,
      personalId: personalId,
      survey: null,
      visaissuance: visaissuance,
      detail: [
        ...(isGovernment
          ? getFieldListConfig.map((field) => ({
            smartName: field.smartName,
            smartId: null,
            partfromId: field.partfromId,
            configsmartId: field.configsmartId,
            linkTable: field.linkTable,
            value: values[field.smartName] || null,
          }))
          : []),
      ],
    };

    console.log("values.document => ", values);
    console.log("prepareData => ", prepareData);

    await dispatch(
      addSmartForm({
        data: prepareData,
      })
    );
  };

  const validationSchema = yup.object({});
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      ...(isGovernment && {
        OrganiztionName: get(detail, "OrganiztionName.value", ""),
        OrganiztionAddress: get(detail, "OrganiztionAddress.value", ""),
        OrganiztionPhone: get(detail, "OrganiztionPhone.value", ""),
        OrganiztionType: get(detail, "OrganiztionType.value", ""),
        RefernceName: get(detail, "RefernceName.value", ""),
        ReferncePosition: get(detail, "ReferncePosition.value", ""),
        RefernceEmail: get(detail, "RefernceEmail.value", ""),
        RefernceMobile: get(detail, "RefernceMobile.value", ""),
        DetailsofActivities: get(detail, "DetailsofActivities.value", ""),
        activitiesId: get(detail, "activitiesId.value", ""),
      }),
      visaissuance: {
        visaInssuanceId: get(smartform, "visaissuance.visaInssuanceId", null),
        overseas: get(smartform, "visaissuance.overseas", true),
        countryId: get(smartform, "visaissuance.countryId", ""),
        cityId: get(smartform, "visaissuance.cityId", ""),
        thailand: get(smartform, "visaissuance.thailand", false),
        theImmigrationBureauID: get(
          smartform,
          "visaissuance.theImmigrationBureauID",
          null
        ),
        oneStopService: get(smartform, "visaissuance.oneStopService", false),
        eec: get(smartform, "visaissuance.eec", false),
        visaTypeId: get(smartform, "visaissuance.visaTypeId", ""),
        visaExp: get(smartform, "visaissuance.visaExp", ""),
      },
    },
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  return (
    <div className={classes.root}>
      <form onSubmit={formik.handleSubmit}>
        <ContentTitle
          title="Application Form"
          subTitle="APPLICATION FOR QUALIFICATION ENDORSEMENT FOR SMART VISA “E”"
        />
        <Steper currentStep={1} stepInfo={REQUEST_DOCUMENT_STEP} />
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            {isGovernment && (
              <TableHead>
                <TableRow>
                  <StyledTableCell colSpan={4}>
                    <Typography variant="h6" className={classes.tableTitle}>
                      Part C : Data of the employer or sponsor in Thailand
                    </Typography>
                  </StyledTableCell>
                </TableRow>
              </TableHead>
            )}
            <TableBody>
              {isGovernment && (
                <>
                  <TableRow>
                    <StyledTableCell colSpan={3}>
                      <div className={classes.cellContent}>
                        <Bagde number={1} />
                        <div className={classes.wrapField}>
                          <InputLabel>Organization Name</InputLabel>
                          <TextField
                            disabled={!canEdit}
                            variant="outlined"
                            className={classes.textField}
                            name="OrganiztionName"
                            value={formik.values.OrganiztionName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError("OrganiztionName", formik)}
                            helperText={getErrorMessage(
                              "OrganiztionName",
                              formik
                            )}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                  </TableRow>

                  <TableRow>
                    <StyledTableCell colSpan={2}>
                      <div className={classes.cellContent}>
                        <Bagde number={2} />
                        <div className={classes.wrapField}>
                          <InputLabel>Address</InputLabel>
                          <TextField
                            disabled={!canEdit}
                            variant="outlined"
                            className={classes.textField}
                            name="OrganiztionAddress"
                            value={formik.values.OrganiztionAddress}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError("OrganiztionAddress", formik)}
                            helperText={getErrorMessage(
                              "OrganiztionAddress",
                              formik
                            )}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell>
                      <div className={classes.cellContent}>
                        <Bagde number={3} />
                        <div className={classes.wrapField}>
                          <InputLabel>Phone number</InputLabel>
                          <TextField
                            disabled={!canEdit}
                            variant="outlined"
                            className={classes.textField}
                            name="OrganiztionPhone"
                            value={formik.values.OrganiztionPhone}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError("OrganiztionPhone", formik)}
                            helperText={getErrorMessage(
                              "OrganiztionPhone",
                              formik
                            )}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                  </TableRow>

                  <TableRow>
                    <StyledTableCell colSpan={4}>
                      <div className={classes.cellContent}>
                        <Bagde number={4} />
                        <div className={classes.wrapField}>
                          <InputLabel>Type of Organization</InputLabel>
                          <FormGroup row>
                            {organiztionTypeConfig.map((organiztionType) => (
                              <FormControlLabel
                                key={organiztionType.organiztionTypeConfigID}
                                control={
                                  <StyleCheckbox
                                    disabled={!canEdit}
                                    name={
                                      organiztionType.organiztionTypeConfigName
                                    }
                                    value={
                                      organiztionType.organiztionTypeConfigID
                                    }
                                    checked={
                                      formik.values.OrganiztionType ===
                                      organiztionType.organiztionTypeConfigID
                                    }
                                    onClick={() => {
                                      formik.setFieldValue(
                                        "OrganiztionType",
                                        organiztionType.organiztionTypeConfigID
                                      );
                                    }}
                                  />
                                }
                                label={
                                  organiztionType.organiztionTypeConfigName
                                }
                              />
                            ))}
                          </FormGroup>
                        </div>
                      </div>
                    </StyledTableCell>
                  </TableRow>

                  <TableRow>
                    <StyledTableCell colSpan={2}>
                      <div className={classes.cellContent}>
                        <Bagde number={5} />
                        <div className={classes.wrapField}>
                          <InputLabel>A reference person’s name</InputLabel>
                          <TextField
                            disabled={!canEdit}
                            variant="outlined"
                            className={classes.textField}
                            name="RefernceName"
                            value={formik.values.RefernceName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError("RefernceName", formik)}
                            helperText={getErrorMessage("RefernceName", formik)}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell>
                      <div className={classes.cellContent}>
                        <Bagde number={0} />
                        <div className={classes.wrapField}>
                          <InputLabel>A reference person’s position</InputLabel>
                          <TextField
                            disabled={!canEdit}
                            variant="outlined"
                            className={classes.textField}
                            name="ReferncePosition"
                            value={formik.values.ReferncePosition}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError("ReferncePosition", formik)}
                            helperText={getErrorMessage(
                              "ReferncePosition",
                              formik
                            )}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                  </TableRow>

                  <TableRow>
                    <StyledTableCell colSpan={2}>
                      <div className={classes.cellContent}>
                        <Bagde number={0} />
                        <div className={classes.wrapField}>
                          <InputLabel>E-mail address</InputLabel>
                          <TextField
                            disabled={!canEdit}
                            variant="outlined"
                            className={classes.textField}
                            name="RefernceEmail"
                            value={formik.values.RefernceEmail}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError("RefernceEmail", formik)}
                            helperText={getErrorMessage(
                              "RefernceEmail",
                              formik
                            )}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell>
                      <div className={classes.cellContent}>
                        <Bagde number={0} />
                        <div className={classes.wrapField}>
                          <InputLabel>Mobile phone number</InputLabel>
                          <TextField
                            disabled={!canEdit}
                            variant="outlined"
                            className={classes.textField}
                            name="RefernceMobile"
                            type="number"
                            value={formik.values.RefernceMobile}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError("RefernceMobile", formik)}
                            helperText={getErrorMessage(
                              "RefernceMobile",
                              formik
                            )}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                  </TableRow>

                  <TableRow>
                    <StyledTableCell colSpan={3}>
                      <div className={classes.cellContent}>
                        <Bagde number={6} />
                        <div className={classes.wrapField}>
                          <InputLabel>
                            Details of activities that applicant will undertake
                            in Thailand; Project description, your role in the
                            project
                          </InputLabel>
                          <TextField
                            disabled={!canEdit}
                            variant="outlined"
                            className={classes.textField}
                            name="DetailsofActivities"
                            value={formik.values.DetailsofActivities}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError("DetailsofActivities", formik)}
                            helperText={getErrorMessage(
                              "DetailsofActivities",
                              formik
                            )}
                            multiline
                            rows={10}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                  </TableRow>

                  <TableRow>
                    <StyledTableCell colSpan={3}>
                      <div className={classes.cellContent}>
                        <Bagde number={7} />
                        <div className={classes.wrapField}>
                          <InputLabel>
                            Please choose the targeted industries most relevant
                            to your expertise
                          </InputLabel>
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{ width: 650 }}
                          >
                            <InputLabel>
                              Selected the targeted industries most relevant to
                              your expertise
                            </InputLabel>
                            <Select
                              disabled={!canEdit}
                              label="Selected the targeted industries most relevant to your
                        company’s activities"
                              name="activitiesId"
                              value={formik.values.activitiesId}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            >
                              {activitiesConfig.map((activities) => (
                                <MenuItem
                                  key={activities.activitiesId}
                                  value={activities.activitiesId}
                                >
                                  {activities.activitiesName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell colSpan={3} style={{ border: 0 }}>
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          height: 100,
                        }}
                      >
                        <InputLabel
                          style={{
                            color: "#8898aa",
                            fontSize: 25,
                          }}
                        >
                          Note: Supplementary sheets may be attached if
                          additional space is required
                        </InputLabel>
                      </div>
                    </StyledTableCell>
                  </TableRow>
                </>
              )}

              <div />
            </TableBody>
          </Table>
        </TableContainer>
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <VisaIssuanceSection colSpan={4} formik={formik} />
          </Table>
        </TableContainer>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            padding: "21px 50px",
          }}
        >
          <b>
            I hereby certify that the information and the evidence provided is
            true and complete in all respects. If there are any false statements
            which are considered perjury, I agree to be subjected to any
            applicable legal prosecution.
          </b>
        </div>
        <ButtonController
          onClickSaveDraft={() => {
            if (!canEdit) {
              dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
              return;
            }
            setSaveDraft(true);
            callAPISubmit(formik.values);
          }}
        />
      </form>
    </div>
  );
}
